(function () {
  'use strict';

  var button = document.querySelector('.pdp__atc');
  if (!button) return;

  var products = {
    'kit-28-jours.html': 'kit',
    'pack-challenge-28-jours': 'kit',
    'dentifrice-siwak.html': 'dentifrice',
    'dentifrice-au-siwak': 'dentifrice',
    'recharge-rituel.html': 'recharge',
    'recharge-rituel': 'recharge',
    'kit-siwak-addict.html': 'siwak-addict',
    'kit-siwak-addict': 'siwak-addict',
    'nanobrosse.html': 'nanobrosse',
    'nanobrosse-clean': 'nanobrosse'
  };
  var file = location.pathname.split('/').pop();
  var product = products[file];
  if (!product) return;

  /* Le point relais n'est offert que la ou il coute moins que la limite de
     4,90 € : France, Belgique, Luxembourg. Ailleurs il reste payant quel que
     soit le panier, abonnement compris, parce que la fonction de remise ne
     reconnait que l'intitule francais du transporteur. Trois marches n'ont
     pas de relais (Suisse, Reunion, Guyane) : le prix se calcule au paiement.
     Meme table que SC_RELAIS dans shopify-runtime.js. */
  var RELAIS_CENTS = { FR: 290, BE: 490, LU: 490, NL: 550, DE: 660, ES: 650, PT: 650, PL: 710, IT: 730 };
  var DOMICILE_CENTS = { CH: 1790, RE: 1200, GF: 1200 };
  var pays = String((window.Shopify || {}).country || 'FR').toUpperCase();
  var portOffrable = ['FR', 'BE', 'LU'].indexOf(pays) >= 0;
  var relayShippingCents = typeof RELAIS_CENTS[pays] === 'number' ? RELAIS_CENTS[pays] : null;
  /* Seuil hors d'atteinte la ou rien n'est jamais offert. */
  var freeRelayThresholdCents = portOffrable ? 3000 : Infinity;
  var subscriptionHasFreeShipping = product !== 'nanobrosse' && portOffrable;

  button.classList.remove('is-hors-perimetre');
  button.removeAttribute('data-hors-perimetre');
  button.removeAttribute('title');
  button.removeAttribute('aria-disabled');

  var label = button.querySelector('.pdp__atc-label');
  var labelInitial = label ? label.textContent.trim() : 'Ajouter au panier';
  var priceNode = button.querySelector('.pdp__atc-price');
  var cures = [].slice.call(document.querySelectorAll('.pdp__cure:not([disabled])'));
  var formats = [].slice.call(document.querySelectorAll('.pdp__flavour:not([disabled])'));
  var quantityLabels = {
    kit: ['Kit sélectionné', 'Kits sélectionnés'],
    recharge: ['Recharge sélectionnée', 'Recharges sélectionnées'],
    dentifrice: ['dentifrice sélectionné', 'dentifrices sélectionnés'],
    'siwak-addict': ['pack sélectionné', 'packs sélectionnés'],
    nanobrosse: ['NanoBrosse sélectionnée', 'NanoBrosses sélectionnées']
  };

  function selectedCure() {
    return document.querySelector('.pdp__cure.is-selected') || cures[0] || null;
  }

  function selectedFormat() {
    return document.querySelector('.pdp__flavour.is-selected');
  }

  function selectedQuantity() {
    var format = selectedFormat();
    var quantity = format ? parseInt(format.getAttribute('data-quantity'), 10) : 1;
    return quantity >= 1 && quantity <= 99 ? quantity : 1;
  }

  function priceToCents(value) {
    var match = String(value || '').match(/\d+(?:[\s.]\d{3})*(?:[,.]\d{2})?/);
    if (!match) return 0;
    return Math.round(parseFloat(match[0].replace(/[\s.]/g, '').replace(',', '.')) * 100);
  }

  function money(cents) {
    /* « 20 € » plutôt que « 20,00 € » (lexique de la masterclass). */
    return (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
  }

  /* Les prix visibles sont ensuite remplacés par les totaux. On conserve donc
     leur valeur unitaire une seule fois, avant la première mise à jour. */
  cures.forEach(function (cure) {
    var current = cure.querySelector('.pdp__price');
    var old = cure.querySelector('.pdp__price-old');
    cure._unitPriceCents = priceToCents(current ? current.textContent : '');
    cure._oldUnitPriceCents = priceToCents(old ? old.textContent : '');
  });

  function formatTotalCents(format) {
    return priceToCents(format && (format.getAttribute('data-total-price') || format.getAttribute('data-prix')));
  }

  function uniqueReferenceCents(format, quantity) {
    var explicitTotal = formatTotalCents(format);
    var unique = cures.filter(function (cure) { return cure.getAttribute('data-cure') === '1'; })[0];
    return explicitTotal || ((unique ? unique._unitPriceCents : 0) * quantity);
  }

  function cureTotalCents(cure, format, quantity) {
    if (!cure) return 0;
    var uniquePurchase = cure.getAttribute('data-cure') === '1';
    var total = 0;
    if (uniquePurchase) total = uniqueReferenceCents(format, quantity);
    /* Chez Shopify, chaque taille de lot souscrit a une cadence differente
       (1 lot = 6 semaines, 2 = 12, 3 = 18) et chaque plan porte son propre
       prix unitaire. Quand la carte declare ce prix, on le prend tel quel :
       l'affichage devient le miroir exact de ce qui sera facture. */
    if (!uniquePurchase) {
      /* v29 : prix exact du lot en abonnement, écrit sur la carte de quantité (panier Shopify vérifié). */
      var aboTotal = format && priceToCents(format.getAttribute('data-abo-total'));
      var uniteAbo = format && priceToCents(format.getAttribute('data-abo-unite'));
      if (aboTotal) return aboTotal;
      if (uniteAbo) total = uniteAbo * quantity;
      else {
        var discount = parseFloat(cure.getAttribute('data-discount-percent')) || 0;
        if (discount > 0) total = Math.round(uniqueReferenceCents(format, quantity) * (100 - discount) / 100);
        else total = cure._unitPriceCents * quantity;
      }
    }
    /* Le Kit 28 jours suit les mêmes paliers de volume que les autres
       bundles. Cet attribut est aussi la source de vérité de l'interface :
       8 % dès 2 Kits, 11 % dès 3 Kits. Shopify arrondit la remise au
       centime sur chaque unité avant de la multiplier par la quantité :
       on reproduit cet ordre de calcul pour afficher exactement le panier. */
    var volumeDiscount = parseFloat(format && format.getAttribute('data-volume-discount')) || 0;
    if (volumeDiscount <= 0) return total;
    var remiseParUnite = Math.floor((total / quantity) * volumeDiscount / 100);
    return total - (remiseParUnite * quantity);
  }

  function totalPriceCents() {
    var cure = selectedCure();
    var format = selectedFormat();
    if (!cure) return 0;
    return cureTotalCents(cure, format, selectedQuantity());
  }

  function quantitySummary(quantity) {
    var labels = quantityLabels[product] || ['article sélectionné', 'articles sélectionnés'];
    return quantity + ' ' + labels[quantity === 1 ? 0 : 1];
  }

  function updateOfferCards(quantity, format) {
    cures.forEach(function (cure) {
      var total = cureTotalCents(cure, format, quantity);
      var displayed = cure.querySelector('.pdp__price');
      if (displayed && total) displayed.textContent = money(total);

      /* Prix livre. Sans cette ligne la page compare 14,90 € a 12,67 € et tait
         les 2,90 € de port qui font pencher la balance : l'abonnement a la
         livraison offerte sans minimum, l'achat unique la paie tant qu'il n'a
         pas franchi le seuil. Les deux cartes affichent donc le meme genre de
         nombre, port compris, et se comparent enfin sur le meme pied.
         La ou il n'y a pas de relais (Suisse, Reunion, Guyane), on ne sait pas
         annoncer un prix livre honnete depuis la fiche : on cache la ligne. */
      var estAbo = cure.getAttribute('data-subscription') === 'true';
      var portDu = estAbo
        ? (subscriptionHasFreeShipping ? 0 : relayShippingCents)
        : (total >= freeRelayThresholdCents ? 0 : relayShippingCents);
      var tete = cure.querySelector('.pdp__tete-prix');
      if (tete && total) {
        var livre = tete.querySelector('[data-livre]');
        if (!livre) {
          livre = document.createElement('span');
          livre.className = 'kx-livre';
          livre.setAttribute('data-livre', '');
          tete.appendChild(livre);
        }
        if (portDu === null) {
          livre.hidden = true;
        } else {
          livre.hidden = false;
          livre.textContent = money(total + portDu) + ' livré';
        }
      }

      var summary = cure.querySelector('.pdp__selection-summary');
      if (!formats.length) { if (summary) summary.remove(); summary = null; }
      else if (!summary) {
        summary = document.createElement('span');
        summary.className = 'pdp__selection-summary';
        var body = cure.querySelector('.pdp__cure-body');
        if (body) body.insertBefore(summary, body.firstChild);
      }
      if (summary) summary.textContent = quantitySummary(quantity);

      var old = cure.querySelector('.pdp__price-old');
      var discount = parseFloat(cure.getAttribute('data-discount-percent')) || 0;
      var reference = discount > 0 ? uniqueReferenceCents(format, quantity) : cure._oldUnitPriceCents * quantity;
      if (old && reference) old.textContent = money(reference);

      var shippingNote = cure.querySelector('[data-shipping-note]');
      if (shippingNote) {
        var freeRelay = total >= freeRelayThresholdCents;
        shippingNote.textContent = freeRelay
          ? 'Livraison offerte en point relais'
          : (relayShippingCents !== null
            ? '+ ' + money(relayShippingCents) + ' en point relais'
            : (typeof DOMICILE_CENTS[pays] === 'number'
              ? '+ ' + money(DOMICILE_CENTS[pays]) + ' à domicile'
              : 'Livraison calculée au paiement'));
        shippingNote.classList.toggle('is-free', freeRelay);
      }

      if (product === 'dentifrice' && discount > 0) {
        var unit = cure.querySelector('.pdp__unit');
        if (unit) unit.textContent = 'Puis ' + money(total) + ' par envoi au lieu de ' + money(reference);
      }
    });

    /* Cartes de format : chacune affiche le total de la formule choisie et
       le prix par jour correspondant. Le nombre de jours vit dans le
       balisage (data-jours), donc la base de calcul reste modifiable sans
       toucher au script. */
    var cureCourante = selectedCure();
    var estAbonnement = !!(cureCourante && cureCourante.getAttribute('data-subscription') === 'true');
    var premiereCarte = document.querySelector('.pdp__flavour[data-quantity="1"]');
    var prixUnitaireReference = premiereCarte ? cureTotalCents(cureCourante, premiereCarte, 1) : 0;
    [].slice.call(document.querySelectorAll('.pdp__flavour')).forEach(function (carte) {
      var n = parseInt(carte.getAttribute('data-quantity'), 10) || 1;
      var totalCarte = cureTotalCents(cureCourante, carte, n);
      var noeudPrix = carte.querySelector('[data-format-prix]');
      if (noeudPrix && totalCarte) noeudPrix.textContent = money(totalCarte);
      var jours = parseInt(carte.getAttribute('data-jours'), 10) || 0;
      var noeudJour = carte.querySelector('[data-format-jour]');
      if (noeudJour) noeudJour.textContent = (jours && totalCarte) ? money(Math.round(totalCarte / jours)) + ' / jour' : '';
      var noeudEconomie = carte.querySelector('[data-format-save]');
      if (noeudEconomie) {
        var prixReference = prixUnitaireReference * n;
        var economie = prixReference > totalCarte ? Math.round((prixReference - totalCarte) * 100 / prixReference) : 0;
        noeudEconomie.hidden = economie < 1;
        noeudEconomie.textContent = economie > 0 ? 'ÉCONOMISEZ ' + economie + ' %' : '';
      }
      var noeudPort = carte.querySelector('[data-format-port]');
      if (noeudPort) {
        var portOffert = estAbonnement
          ? subscriptionHasFreeShipping
          : totalCarte >= freeRelayThresholdCents;
        noeudPort.hidden = !carte.classList.contains('is-selected') || !portOffert;
        noeudPort.textContent = estAbonnement
          ? 'Offert à chaque envoi, sans minimum'
          : 'Livraison offerte en point relais';
      }
    });

    var subscription = cures.filter(function (cure) { return cure.getAttribute('data-subscription') === 'true'; })[0];
    if (subscription) {
      var subscriptionTotal = cureTotalCents(subscription, format, quantity);
      [].slice.call(document.querySelectorAll('[data-subscription-total]')).forEach(function (node) {
        node.textContent = money(subscriptionTotal);
      });
    }
  }

  function multipleLabel(quantity, uniquePurchase) {
    var nouns = {
      kit: 'Kits',
      recharge: 'recharges',
      dentifrice: 'tubes',
      'siwak-addict': 'packs',
      nanobrosse: 'NanoBrosses'
    };
    return 'Je commande ' + quantity + ' ' + (nouns[product] || 'articles');
  }

  function updatePurchase() {
    var cure = selectedCure();
    if (!cure) return;
    var quantity = selectedQuantity();
    var uniquePurchase = cure.getAttribute('data-cure') === '1';
    var abonnement = cure.getAttribute('data-subscription') === 'true';
    var totalCents = totalPriceCents();
    var format = selectedFormat();
    updateOfferCards(quantity, format);
    if (priceNode && totalCents) priceNode.textContent = money(totalCents);
    /* Le bouton parle du Rituel quand le Rituel est retenu : c'est le mot
       de la marque, « abonnement » ne vend pas. Le libelle vit dans le
       balisage (data-label-abo) pour rester modifiable par page sans
       toucher au script. A plusieurs exemplaires, le libelle de quantite
       reprend la main, il porte une information que l'autre n'a pas. */
    var libelleAbo = button ? button.getAttribute('data-label-abo') : null;
    var libelleCarte = cure.getAttribute('data-atc-label');
    if (label) {
      /* v29 : la carte peut porter son libellé ; en abonnement, le bouton dit « Je m'abonne »
         quelle que soit la quantité ; sinon libellé de quantité ou libellé d'achat (data-label-unique). */
      var libelleUnique = button.getAttribute('data-label-unique') || labelInitial;
      if (libelleCarte) label.textContent = libelleCarte;
      else if (abonnement && libelleAbo) label.textContent = libelleAbo;
      else if (quantity > 1) label.textContent = multipleLabel(quantity, uniquePurchase);
      else label.textContent = libelleUnique;
    }
    var stockLabel = document.querySelector('.pdp__stock-label');
    var stockText = format && format.getAttribute('data-stock');
    if (stockLabel && stockText) stockLabel.textContent = stockText;
  }

  cures.forEach(function (cure) {
    cure.addEventListener('click', updatePurchase);
  });
  formats.forEach(function (format) {
    format.addEventListener('click', updatePurchase);
  });

  /* Choix initial : la carte de quantité cochée dans le balisage (1 unité). v29 (12/10, Xebec) :
     la formule cochée d'avance est la carte marquée data-defaut (l'abonnement sur chaque fiche). */
  var defaultFormat = document.querySelector('.pdp__flavour.is-selected') || formats[0];
  if (defaultFormat) defaultFormat.click();
  /* 08/10 (Xebec) : sur le Kit, la formule cochée par défaut est « Kit + 1 Recharge » (achat unique,
     meilleure marge). Le Rituel (abonnement) n'est jamais coché d'avance. Si le pack n'est pas en vente
     sur le site en ligne, on retombe sur le Kit seul. */
  function parCode(code) { return cures.filter(function (c) { return c.getAttribute('data-cure') === code; })[0]; }
  var pack = parCode('bundle');
  /* v28 (12/10, Xebec) : une carte marquée data-defaut (le Rituel sur le Kit) est cochée d'avance. */
  var marquee = cures.filter(function (c) { return c.hasAttribute('data-defaut'); })[0];
  var defaultCure = marquee || pack || parCode('1') || cures[0];
  if (defaultCure) defaultCure.click();
  updatePurchase();
  var enLigne = window.Shopify && Shopify.theme && Shopify.theme.role === 'main';
  if (pack && enLigne && window.fetch) {
    fetch('/variants/' + pack.getAttribute('data-variant-id') + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (v) {
      if (v && v.available) return;
      pack.hidden = true;
      if (pack.classList.contains('is-selected')) { var u = parCode('1'); if (u) u.click(); updatePurchase(); }
    }).catch(function () {});
  }

  var alternative = document.querySelector('.pdp__trust-alt[role="button"]');
  if (alternative) {
    alternative.classList.remove('is-hors-perimetre');
    alternative.removeAttribute('data-hors-perimetre');
    alternative.removeAttribute('title');
    alternative.removeAttribute('aria-disabled');
    function chooseUnique() {
      if (cures[0]) cures[0].click();
      updatePurchase();
      button.focus();
    }
    alternative.addEventListener('click', chooseUnique);
    alternative.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        chooseUnique();
      }
    });
  }

  button.addEventListener('click', function () {
    var quantity = selectedQuantity();
    var totalCents = totalPriceCents();
    var unitCents = totalCents / quantity;
    if (window.SiwakCartDrawer) {
      window.SiwakCartDrawer.add(product, {price:unitCents, qty:quantity, replace:true});
      return;
    }
    location.href = 'panier.html?add=' + encodeURIComponent(product) + (unitCents > 0 ? '&price=' + Math.round(unitCents) : '') + '&qty=' + quantity;
  });
})();
